export default __webpack_public_path__ + "static/media/GST-CERTIFICATE-INSHA-BANGALES-PVT-LTD.23f36b7a.jpg";